/**
 * Tab Content component - renders Benefits, Recruitment, or Skills content
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '../../../../../components/icons/Icon';
import { getIconForItem } from '../utils/iconMapping';

export interface TabContentProps {
  activeTab: 'Benefits' | 'Recruitment' | 'Skills';
  benefits?: string[];
  recruitmentProcess?: string[];
  skillsAndTechnologies?: string[];
}

export const TabContent: React.FC<TabContentProps> = ({
  activeTab,
  benefits,
  recruitmentProcess,
  skillsAndTechnologies,
}) => {
  let items: string[] = [];
  if (activeTab === 'Benefits' && benefits) items = benefits;
  else if (activeTab === 'Recruitment' && recruitmentProcess) items = recruitmentProcess;
  else if (activeTab === 'Skills' && skillsAndTechnologies) items = skillsAndTechnologies;

  // Recruitment stepper rendering
  if (activeTab === 'Recruitment' && items && items.length > 0) {
    return (
      <div className="mt-4 flex flex-col gap-1 pt-2">
        <ol className="relative border-l border-gray-200 dark:border-gray-700 ml-3">
          {items.map((item, idx) => (
            <li key={idx} className="mb-8 ml-4 last:mb-0">
              <span className="absolute -left-3 flex items-center justify-center w-6 h-6 bg-blue-100 dark:bg-blue-900 rounded-full ring-2 ring-white dark:ring-gray-900">
                <span className="text-blue-600 dark:text-blue-300 font-bold text-xs">{idx + 1}</span>
              </span>
              <div className="text-xs text-gray-700 dark:text-gray-200 font-medium pl-2">{item}</div>
              {idx < items.length - 1 && <span className="block w-0.5 h-6 bg-gray-200 dark:bg-gray-700 absolute left-0 top-6"></span>}
            </li>
          ))}
        </ol>
      </div>
    );
  }

  // Default rendering for Benefits and Skills
  return (
    <div className="mt-4 flex flex-col gap-1 pt-2">
      {items && items.length > 0 ? (
        items.map((item, idx) => {
          const { name, variant } = getIconForItem(item);
          return (
            <span key={idx} className="flex items-center gap-2 text-xs text-gray-500 font-normal" title={item}>
              <Icon name={name} variant={variant} useMaskForColor className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" />
              <span className="truncate">{item}</span>
            </span>
          );
        })
      ) : (
        <span className="text-xs text-gray-400 italic">
          <FormattedMessage id="jobDetailPage.noItems" defaultMessage="No items to show." description="Message shown when a chart or list has no data to display" />
        </span>
      )}
    </div>
  );
};

